import { LOCALES, DEFAULT_LOCALE, SERVICE_NUMBER } from '../../../const/i18n';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = () => ({
  locales: LOCALES,
  currentLocale: DEFAULT_LOCALE,
  serviceNumber: SERVICE_NUMBER
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};